var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    transform: "translate(4.500000, 6.500000) scale(-1, 1) translate(-4.500000, -6.500000) ",
    fill: "#00A2E9",
    stroke: "#FFFFFF",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.40351836,1.03139538 L1.04651836,5.38839538 C0.725761603,5.71039988 0.563625067,6.15764784 0.603518363,6.61039538 C0.563625067,7.06314291 0.725761603,7.51039087 1.04651836,7.83239538 L5.40451836,12.1893954 C6.0062326,12.7908335 6.98158027,12.7906096 7.58301836,12.1888954 C8.18445646,11.5871811 8.1842326,10.6118335 7.58251836,10.0103954 L4.18251836,6.61039538 L7.58251836,3.21039538 C8.16723015,2.60584681 8.15921002,1.6441295 7.56449713,1.04941661 C6.96978424,0.454703721 6.00806693,0.446683591 5.40351836,1.03139538 Z",
    id: "Union_17",
    transform: "translate(4.315759, 6.619198) rotate(180.000000) translate(-4.315759, -6.619198) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.a1d5e45ee1059476cdbfd7c455701d7d.svg";
export { ForwardRef as ReactComponent };